import { DialogContentText, TextField } from "@mui/material";
import { createRIO, updateRIO } from "../api/requests/RIO";
import { useAlert } from "../context/AlertContext";
import { commonStrings } from "../static/commonStrings";
import { RIOType } from "../utils/types";
import CommonDialog from "./common/CommonDialog";
import React, { useState } from "react";
const CreateOrEditRIO = ({
  setOpenCreateDialog,
  onSaveRIOCB,
  isEdit = false,
  rioData,
}: {
  setOpenCreateDialog: () => void;
  onSaveRIOCB: () => void;
  isEdit?: boolean;
  rioData?: RIOType;
}) => {
  const [rioName, setRIOName] = useState<string>(
    isEdit ? rioData?.rioName ?? "" : ""
  );
  const { showAlert } = useAlert();

  const handleSaveRIO = async () => {
    const createRIORes = await createRIO(rioName!);
    if (createRIORes.status == 200) {
      showAlert("Added successfully", "success");
    }
    onSaveRIOCB();
  };

  const handleRIO = async () => {
    if (rioData) {
      const editRIORes = await updateRIO(rioData.rioId, rioName!);
      if (editRIORes.status == 200) {
        showAlert("Edited successfully", "success");
      }
      onSaveRIOCB();
    }
  };

  const dialogTitle = `${isEdit ? "Edit" : "Create"} ${
    commonStrings.sideBarMenuTitles.rio
  }`;

  return (
    <CommonDialog
      title={dialogTitle}
      cancelButton={() => setOpenCreateDialog()}
      actionButtonTitle="Save"
      cancelButtonTitle="Cancel"
      actionButton={isEdit ? handleRIO : handleSaveRIO}
      disableActionButton={!rioName}
    >
      <DialogContentText>
        <TextField
          fullWidth
          value={rioName}
          onChange={(value) => setRIOName(value.target.value)}
          label={`Enter ${commonStrings.sideBarMenuTitles.rio}`}
        />
      </DialogContentText>
    </CommonDialog>
  );
};

export default CreateOrEditRIO;
